/** Matches the backend agent id (the ts-rest `:agentId`). */
export const CLINICAL_FINDINGS_AGENT_ID = 'extract-clinical-findings';

/** Coding systems a reviewer can assign when editing a finding. `label` is the
 *  short name shown in the review list (matches the backend's `summarize`);
 *  `url` is the FHIR system the edit endpoint stores. `available` reflects
 *  whether we have that code set loaded to search + validate against — only
 *  ICD-10-CM today, so the others render disabled. Mirror the backend's
 *  `VALIDATED_CODE_SYSTEMS` when a new set is loaded. */
export const CODE_SYSTEMS = [
  { label: 'SNOMED', url: 'http://snomed.info/sct', available: false },
  {
    label: 'ICD-10-CM',
    url: 'http://hl7.org/fhir/sid/icd-10-cm',
    available: true,
  },
  { label: 'LOINC', url: 'http://loinc.org', available: false },
] as const;

/** The system the edit picker searches + validates against. ICD-10-CM is the
 *  only code set loaded into the DB today, so it's the only one we can validate;
 *  the picker scopes to it. */
export const ICD_10_CM_SYSTEM = 'http://hl7.org/fhir/sid/icd-10-cm';

/** Short label for a coding-system URL (to show the current code as a chip),
 *  falling back to the raw URL for systems not in the list. */
export function codeSystemLabel(url: string | null): string | null {
  if (!url) return null;
  return CODE_SYSTEMS.find((s) => s.url === url)?.label ?? url;
}
